import { LoadingOutlined } from '@ant-design/icons'
import PrintEmailContent from '@components/PrintEmailContent'
import { ApiService } from '@services/ApiService'
import router from '@stores/router'
import { getQueryParams } from '@utils/functions'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'

const Template = () => {
  const { id, type } = getQueryParams(
    router.location.search,
    router.location.state
  )
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)

  useEffect(() => {
    document.title = getTabName(type)
    if (id) {
      setLoading(true)
      getTemplate(id, getFunctionGetTemplate(type))
    } else {
      setError(new Error('Missing parameter id'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getTabName = type => {
    switch (type) {
      case 'checklist':
        return 'Telehealth Checklist'
      case 'consentForm':
        return 'Consent Form'
      case 'appointmentConfirmationCM':
        return 'Appointment Confirmation Case Manager'
      case 'appointmentConfirmationSpecialist':
        return 'Appointment Confirmation Specialist'
      default:
        return 'kawaconn Template'
    }
  }

  const getFunctionGetTemplate = type => {
    switch (type) {
      case 'consentForm':
        return ApiService.Assessment.ViewConsentForm
      case 'checklist':
        return ApiService.Assessment.ViewCheckList
      case 'appointmentConfirmationCM':
        return ApiService.Assessment.ViewAppointmentConfirmationCM
      case 'appointmentConfirmationSpecialist':
        return ApiService.Assessment.ViewAppointmentConfirmationSpecialist
      default:
        return null
    }
  }

  const getTemplate = async (id, functionGetTemplate) => {
    try {
      const { data } = await functionGetTemplate(id)
      setData(data)
      setLoading(false)
      if (!data) {
        throw new Error('Cannot found')
      }
    } catch (err) {
      setLoading(false)
      setError(err)
    }
  }

  if (loading) {
    return (
      <div
        className="flex justify-center items-center"
        style={{ height: window.innerHeight }}
      >
        <LoadingOutlined
          style={{ fontSize: '75px', color: 'var(--blue-400)' }}
        />
      </div>
    )
  }

  if (error) {
    // Prefer the message the API sent. Falling back to error.message alone would show axios's
    // "Request failed with status code 403", which tells the user nothing about why — and this
    // page is how an offshore user finds out printing is not available to them.
    const apiMessage =
      error?.response?.data?.error?.message ||
      error?.response?.data?.error?.details

    return (
      <div className="container text-lg">
        <h1>{apiMessage ? 'Not available' : 'Something Error'}</h1>
        <p>{apiMessage || error.message}</p>
      </div>
    )
  }

  if (!data) {
    return null
  }

  // Standalone full-page viewer (opened in its own tab via EmptyLayout). The
  // template is a full A4 HTML document; PrintEmailContent renders it directly as
  // a centred print region so the browser prints it natively on every trigger
  // (Ctrl+P, right-click ▸ Print, File ▸ Print) without iframe scroll quirks.
  return (
    <PrintEmailContent html={data} title={getTabName(type)} pageMargin="15mm" />
  )
}

export default observer(Template)
